<template>
  <router-link :to="to" class="hos-card">
    <div class="hos-top">
      <span class="hos-label">{{ title }}</span>
      <span class="hos-value">{{ total }}</span>
    </div>
    <span class="hos-sub">{{ total > 1 ? $t('post.stats.opentickets') : $t('post.stats.openticket') }}</span>
    <div class="hos-bar">
      <div class="hos-bar-fill" :style="{ width: (width || 0) + '%' }"></div>
    </div>
  </router-link>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
  name: 'HomeOpenedTicketsStat',
  props: ['title', 'total', 'width', 'to']
}
</script>

<style scoped>
.hos-card {
  display: block;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  text-decoration: none !important;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.hos-card:hover {
  border-color: #bfdbfe;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.1);
  transform: translateY(-2px);
}

.hos-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.hos-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.hos-value {
  font-size: 1.4rem;
  font-weight: 800;
  color: #1e293b;
}

.hos-sub {
  font-size: 0.72rem;
  color: #94a3b8;
  display: block;
  margin-bottom: 10px;
}

.hos-bar {
  width: 100%;
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
}

.hos-bar-fill {
  height: 100%;
  border-radius: 3px;
  background: #10b981;
  transition: width 0.6s ease;
}
</style>
